import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history'
});

router.beforeEach((to, from, next) => {
	// Clear the print context to restore normal UI when the user goes back
	if (Store.state.printContext) {
		Store.commit('setPrintContext', null);
	}

	next();
});

export default router;
